
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#7CB04B","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M37.584 28.39c-5.406 0-9.806 4.401-9.806 9.807 0 5.405 4.4 9.801 9.806 9.801 5.406 0 9.801-4.396 9.801-9.801 0-5.406-4.395-9.807-9.801-9.807zm0 17.977c-4.504 0-8.17-3.666-8.17-8.17s3.666-8.17 8.17-8.17 8.17 3.666 8.17 8.17-3.666 8.17-8.17 8.17z"}}),_c('path',{attrs:{"d":"M42.487 37.379h-4.085v-4.085a.82.82 0 00-1.636 0v4.903c0 .45.367.818.818.818h4.903c.45 0 .813-.368.813-.818a.815.815 0 00-.813-.818zM22.062 17.771H5.722v23.693h16.34V26.759h14.704v-8.988H22.062zm7.352 7.352h5.716v-5.72h-5.716v5.72zm-14.71 0h5.722v-5.72h-5.722v5.72zm-7.352 0h5.721v-5.72h-5.72v5.72zm0 7.353h5.721v-5.717h-5.72v5.717zm0 7.352h5.721v-5.716h-5.72v5.716zm7.352 0h5.722v-5.716h-5.722v5.716zm0-7.352h5.722v-5.717h-5.722v5.717zm7.358-7.353h5.716v-5.72h-5.716v5.72z"}}),_c('path',{attrs:{"d":"M26.96 45.549H1.636V13.686h39.215v10.62a.819.819 0 001.636 0V4.697a.82.82 0 00-.818-.818h-4.085V1.43a.82.82 0 00-.818-.817h-5.721a.815.815 0 00-.813.818V3.88H12.255V1.43a.819.819 0 00-.818-.817H5.721a.816.816 0 00-.818.818V3.88H.818A.82.82 0 000 4.698v41.669c0 .45.367.818.818.818H26.96a.817.817 0 00.818-.818.816.816 0 00-.818-.818zm4.903-38.402h4.085V2.249h-4.085v4.898zm-25.329 0h4.085V2.249H6.534v4.898zM1.636 5.516h3.267v2.449c0 .451.363.818.818.818h5.716a.819.819 0 00.818-.818v-2.45h17.977v2.45c0 .451.362.818.813.818h5.721a.82.82 0 00.818-.818v-2.45h3.267v6.535H1.636V5.516z"}})])])
          )
        }
      }
    